import {Injectable} from '@angular/core';
import {environment} from '~local/environments/environment';
import {BehaviorSubject, Observable} from 'rxjs';

export type Credentials = {
    // Customize received credentials here
    email: string;
    token: string;
    id: number;
};

/**
 * Provides storage for authentication credentials.
 * The Credentials interface should be replaced with proper implementation.
 */
@Injectable()
export class CredentialsService {
    private _credentials = new BehaviorSubject<Credentials | null>(null);

    constructor() {
        const savedCredentials = sessionStorage.getItem(environment.credentialsKey);
        if (savedCredentials) {
            this._credentials.next(JSON.parse(savedCredentials));
        }
    }

    public setCredentials(credentials: Credentials | null = null) {
        this._credentials.next(credentials);

        if (credentials) {
            sessionStorage.setItem(environment.credentialsKey, JSON.stringify(credentials));
        } else {
            sessionStorage.removeItem(environment.credentialsKey);
        }
    }

    get credentials$(): Observable<Credentials | null> {
        return this._credentials.asObservable();
    }

    get credentials(): Credentials | null {
        return this._credentials.value;
    }

}
